import { useMemo } from 'react';
import { useProjects } from '@/pages/ProjectsLegacy/ProjectsLegacy.hooks';
import { useAgentsListQuery } from '@/services/bff/bff.queries';

interface UseSearchDataParams {
    projectId: string;
    agentId: string;
}

export const useSearchData = ({ projectId, agentId }: UseSearchDataParams) => {
    const { projects, isProjectsLoading } = useProjects();

    const {
        data: agentsData,
        isLoading: isAgentsLoading,
        error: agentsError
    } = useAgentsListQuery(projectId ? { project_id: projectId } : undefined);

    const flows = useMemo(() => {
        if (!agentId || !agentsData) return [];
        const selectedAgent = agentsData.find((agent) => agent.id === agentId);
        return selectedAgent?.flows ?? [];
    }, [agentId, agentsData]);

    return {
        projects,
        agents: agentsData,
        flows,
        isLoading: isProjectsLoading || isAgentsLoading,
        error: agentsError
    };
};
